(function () {
	'use strict';

	angular.module('widgets.supplychain')
		.directive('poPlacementMonthlyChartWidget', poPlacementMonthlyChartWidget);

	function poPlacementMonthlyChartWidget($compile, $filter, $window, $timeout, $rootScope,
			hostUrl, getJsonData, percentageFormatService, numberFormatService, integerFormatService,
	   	$translate, formatterService, WEEKLY_LOG_ITEM_FIELDS) {
		// current services that are being used, will need to add them to this object if we add more
		var services = {
			'percentageFormatService': percentageFormatService,
			'numberFormatService': numberFormatService,
			'integerFormatService': integerFormatService
		};
		return {
			link: function (scope, elem, attrs) {
				var chart;
				var generateListener;
				elem[0].id = elem[0].id + scope.$id;
				var scopeAccessor = scope.$parent.$parent;
				var widgetHeight = 100;
				var numAxisTicks = 3;
				var slideshow = false;
				scope.paddingTop = 4;
				var w = angular.element($window);
				var width = Math.max(w.width(), window.innerWidth);
				scope.height = window.innerHeight;
				if (jQuery(elem[0]).parents('.slideshowWidget').length) {
					widgetHeight = scope.height - 130 - 95;
					numAxisTicks = 5;
					//change bgNum container height
					var parent = jQuery(elem[0]).parent();
					scope.paddingLeft = 75;
					scope.paddingTop = 8;
					slideshow = true;
				}

				//get the window width to help with responsiveness

				if (width > 992) {
					scope.paddingRight = 52;
					scope.paddingLeft = slideshow ? 75 : 59;
				} else if (width >= 768) {
					scope.paddingRight = 37.6;
					scope.paddingLeft = slideshow ? 75 : 48;
				} else {
					scope.paddingRight = 33.2;
					scope.paddingLeft = slideshow ? 75 : 36;
				}

				scope.getWindowDimensions = function () {
					return {
						'w': Math.max(w.width(), window.innerWidth),
						'h': window.innerHeight
					};
				};

				scope.$watch(scope.getWindowDimensions, function (newValue, oldValue) {
					scope.windowWidth = newValue.w;
					scope.height = newValue.h;
					var currentPaddingLeft = scope.paddingLeft;
					if (scope.windowWidth >= 992) {
						scope.paddingRight = 52;
						scope.paddingLeft = slideshow ? 75 : 59;
					} else if (scope.windowWidth >= 768) {
						scope.paddingRight = 37.6;
						scope.paddingLeft = slideshow ? 75 : 48;
					} else {
						scope.paddingRight = 33.2;
						scope.paddingLeft = slideshow ? 75 : 36;
					}

					if (currentPaddingLeft !== scope.paddingLeft || slideshow) {
						generateChart();
					}
				}, true);

				w.bind('resize', function () {
					scope.$apply();
				});

				//reading in the chart properties for this chart
				var chartKey = scope.chartId;
				var eventName = chartProperties[chartKey].eventName;
				var fmtService = services[chartProperties[chartKey].fmtService];

				var yMax;
				var yMin;

				function getYMaxAndMin(curMin, curMax, numTicks, integer) {
					var multiple = numTicks - 1;
					yMax = curMax;
					yMin = curMin;
					yMin = yMin * 0.95;
					yMax = yMax * 1.05;
					if (integer) {
						yMin = Math.floor(yMin);
						yMax = Math.ceil(yMax);
						var diff = yMax - yMin;
						var newDiff = Math.ceil(diff / multiple) * multiple;
						yMax = yMin + newDiff;
					}
				}

				var generateChart = function () {
					var data = scopeAccessor.chartData;
					if (!data) {
						return;
					}

					var yAxisFieldKey = chartProperties[chartKey].yAxisFieldKey;
					var xAxisField = 'date';
					var dateList = [];

					angular.forEach(data, function (d) {
						d[xAxisField] = new Date(d['calendarYear'], d['calendarMonth'] - 1, 15);
						dateList.push($filter('date')(d[xAxisField], 'MMM yyyy', 'UTC'));
					});

					var currency = scopeAccessor.currency;
					var settings = scopeAccessor.settings;
					var groups = ['lateGreaterThan14Days', 'late7To14Days', 'late7Days', 'onTime'];

					var xGridLines = [];

					if (scopeAccessor.delta) {
						//this is being used for the graphs with daily data points rather than weekly
						scope.$parent.diff = scopeAccessor.delta;
					} else {
						var diff = {};
						diff.delta = data[data.length - 1]['monthlyOnTimePercent'] || 0;
						diff.delta -= data[data.length - 2]['monthlyOnTimePercent'] || 0;

						diff.status = (diff.delta > 0) ? 'good' : 'bad';
						scope.$parent.diff = diff;
					}

					// gridlines
					if (data.length >= 2) {
						var middle = dateMidpoint(data[0][xAxisField], data[data.length - 1][xAxisField]);
						var middle2 = dateMidpoint(data[0][xAxisField], middle);
						var middle3 = dateMidpoint(data[data.length - 1][xAxisField], middle);
						xGridLines = [
							{
								value: data[0][xAxisField]
							}, {
								value: data[data.length - 1][xAxisField]
							},
							{
								value: middle
							}, {
								value: middle2
							}, {
								value: middle3
							}
						];
					}

					var min = 0;
					var max = 0;
					if (data.length) {
						min = data[0][yAxisFieldKey];
						max = data[0][yAxisFieldKey];
						for (var i = 0; i < data.length; i++) {
							if (!data[i][yAxisFieldKey] && data[i][yAxisFieldKey !== 0]) {
								continue;
							}
							if (data[i][yAxisFieldKey] < min || (!min && min !== 0)) {
								min = data[i][yAxisFieldKey];
							}
							if (data[i][yAxisFieldKey] > max) {
								max = data[i][yAxisFieldKey];
							}
						}
					}
					getYMaxAndMin(min, max, numAxisTicks,
						chartProperties[chartKey].fmtService === 'integerFormatService');
					//format the diff
					var formattedDiff = {};
					formattedDiff.delta = services['percentageFormatService'].getWithParameters(scope.$parent.diff.delta, 0);

					scope.$parent.formattedDiff = formattedDiff;
					scope.$parent.formattedDiff.addnlLabelText = 'since last month';
					var config = {};
					config.bindto = '#' + elem[0].id;
					config.data = {};
					config.data.json = data;
					config.data.keys = {};
					config.data.keys.value = ['monthlyOnTimePercent'].concat(groups);
					config.point = {
						r: 3.5,
						focus: {
							expand: {
								r: 4.5
							}
						}
					};

					config.data.type = 'bar';
					config.data.types = {
						monthlyOnTimePercent: 'line'
					};

					config.data.axes = {
						monthlyOnTimePercent: 'y2'
					};
					config.data.groups = [groups];
					config.data.colors = {
						'onTime': '#168F3D',
						'late7Days': '#F1C60A',
						'late7To14Days': '#FF9B30',
						'lateGreaterThan14Days': '#C6000B',
						'monthlyOnTimePercent': '#000000'
					};
					config.data.order = null;

					config.padding = {
						right: scope.paddingRight,
						left: scope.paddingLeft,
						top: scope.paddingTop
					};
					config.axis = {
						x: {
							type: 'category',
							categories: dateList,
							tick: {
								count: 5,
								outer: false,
								multiline: false
							},
							height: 50
						},
						y: {
							tick: {
								format: function (x) {
									return fmtService.get(x, currency);
								},
								count: numAxisTicks
							},
							min: 0,
							max: yMax,
							padding: {
								bottom: 0,
								top: 0
							}
						},
						y2: {
							show: true,
							min: 0,
							max: 100,
							tick: {
								count: 6,
								format: percentageFormatService.get
							},
							padding: {
								bottom: 0,
								top: 0,
								right: 10
							}
						}
					};

					config.size = {};
					config.size.height = widgetHeight + (groups && !slideshow ? 100 : 0);
					config.data.names = {
						'onTime': $translate.instant('On Time'),
						'late7Days': $translate.instant('Late < 7 Days'),
						'late7To14Days': $translate.instant('Late 7 - 14 Days'),
						'lateGreaterThan14Days': $translate.instant('Late > 14 Days'),
						'monthlyOnTimePercent': $translate.instant('On Time %')
					};
					config.legend = {
						show: true,
						item: {
							onclick: function (id) {
								chart.toggle(id);
								var selectedKeys = [];
								// update bgnum and delta
								var i;
		
								var visibleData = chart.data.shown();
								for (i = 0; i < visibleData.length; i++) {
									 selectedKeys.push(visibleData[i].id);
								}
								scope.$parent.bgHide = !(selectedKeys.length === 5 || 
									(_.sortBy(selectedKeys).toString() === _.sortBy(this.config.data_groups[0]).toString()));
							}
						}
					};
					config.grid = {
						x: {
							lines: xGridLines
						},
						y: {
							show: true
						}
					};

					config.onrendered = function () {
						jQuery('#' + elem.attr('id') + ' .c3-xgrid-lines').prependTo(
							jQuery('#' + elem.attr('id') + ' .c3-grid').first());
						d3.selectAll('.c3-legend-item-monthlyOnTimePercent .c3-legend-item-tile').classed('line-shape', true);
					};
					chart = c3.generate(config);
				};

				generateListener = scope.$on(eventName, function () {
					generateChart();
				});

				scope.$on('$destroy', function () {
					if (chart) {
						chart.destroy();
					}
					if (generateListener) {
						generateListener();
					}
				});

			}
		};
	}
})();
